import { ProjectSheet } from '../ProjectSheet'
import { useProjectSelectOptions } from '../../hooks/projectSelectOptions'
import { useProjectEditBasicInformationTableDef } from './basic-information-table-def/edit'
import {
  ProjectEditDialogConfig,
  useProjectEditDialogData,
} from '../../hooks/projectEditDialogData'
import { APPLICATION_FUNCTION_EXTERNAL_ID } from '../../..'

type Props = {
  dialog: ProjectEditDialogConfig
  // LayerDialog が渡す閉じる導線（未保存なら確認ダイアログを出して閉じる）。
  onRequestClose?: () => void
}

// FunctionLayer 上でプロジェクト単票を開くダイアログ版。登録時はDB保存せず、入力値を
// 呼び出し元へ返して閉じる（ProgramManagement などから利用）。
export const ProjectEditDialog = ({ dialog, onRequestClose }: Props) => {
  const data = useProjectEditDialogData(dialog)
  const options = useProjectSelectOptions()
  const tableDef = useProjectEditBasicInformationTableDef(
    data.isCreating,
    options
  )
  return (
    <ProjectSheet
      functionExternalId={APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_REGISTRATION}
      {...data}
      tableDef={tableDef}
      // × は LayerDialog の confirmClose に通す（全ての閉じ方と挙動を統一）。
      onClose={onRequestClose}
    />
  )
}
